


















import Vue, { PropType } from "vue"
import ButtonFloatingFrame from "~/components/custom/buttonFrame/BottomFloatingFrame.vue"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"
import { FreeAppliableProject } from "~/clApi/viewModel/corporationAccount"

export default Vue.extend({
  components: {
    ButtonFloatingFrame,
    ConversionButton,
  },
  props: {
    freeAppliableProject: {
      type: Object as PropType<FreeAppliableProject>,
      required: true,
    },
  },
  methods: {
    navigateTo(url: string): void {
      window.open(url, "_blank", "noopener,noreferrer")
    },
    checkIsLastLink(idx: number): boolean {
      return idx === this.freeAppliableProject.attachedLinks.length - 1
    },
  },
})
